import apiServiceCall from "../services/ApiServiceCall";

export const registerService = (request: registerRequest) => {
  return apiServiceCall()
    .post("/pending/create-solo", request)
    .then(({ data }: registerServiceResponse) => data);
};

export const registerLimitService = () => {
  return apiServiceCall()
    .get("/pending/formAvailable")
    .then(({ data }: IRegisterLimitServiceResponse) => data);
};

export const validateTokenService = (token: string) => {
  return apiServiceCall()
    .get(`/pending/validate-token-solo?token=${token}`)
    .then(({ data }: registerServiceResponse) => data);
};

export interface IRegisterLimitServiceResponse {
  data: {
    available: boolean;
  };
}

export interface registerRequest {
  token: string;
  sponsored_players: boolean;
  sponsor: string;
  proam: number;
  name: string;
  lastname: string;
  email: string;
  phone_number: string;
  mobile_number: string;
  company: string;
  document_type: number;
  document_number: string;
  sex: number;
  tshirt_size: number;
  ghin: number;
  handicap: number;
  diestro: number;
  glove_size: number;
  include_guest: boolean;
  guest_name: string;
  guest_lastname: string;
  guest_email: string;
  guest_document_type: string;
  guest_document: string;
}

interface registerServiceResponse {
  data: {
    proam_courtesy: boolean;
    proam: boolean;
    ok: boolean;
    msg: string;
    error: string;
  };
}
